import {OrderCardForm} from './App/Components/OrderCardForm.js';

document.addEventListener('DOMContentLoaded', () => {
    const orderCardForm = new OrderCardForm();
    orderCardForm.init();
});
